// A WebView whitelist miss launches the URL through Linking before consulting
// our callback. Mac previews therefore use ['*'] and apply this policy to every
// navigation, including custom schemes, subframes and target=_blank requests.
export function previewWebLink(value) {
  if (typeof value !== 'string' || value.length > 4096 || /[\x00-\x20\x7f]/.test(value)) return null;
  try {
    // Do not use the Mac bootstrap's minimal global URL implementation: it
    // leaves username/password empty and does not update href after hash edits.
    const url = new PreviewURL(value);
    if (!['https:', 'http:'].includes(url.protocol) || url.username || url.password) return null;
    return url.href;
  } catch { return null; }
}

function documentUrl(value) {
  if (typeof value !== 'string') return null;
  try { const url = new PreviewURL(value); url.hash = ''; return url.href; } catch { return null; }
}

export function macArtifactNavigation(request, source) {
  const url = request?.url;
  if (typeof url !== 'string' || url.length > 8192) return 'block';
  const current = documentUrl(url);
  const initial = documentUrl(source?.uri || source?.baseUrl || 'about:blank');
  if (current && current === initial && isPreparedMacPdfFile(current)) return 'allow';
  // Only the supplied document and in-document anchors may replace the page.
  if (current && current === initial && (current === 'about:blank' || previewWebLink(url))) return 'allow';
  if (request?.isTopFrame === false) {
    // Keep ordinary HTTPS embeds and inline frames working, without handing
    // their redirects or custom schemes to another application.
    if (url === 'about:blank' || url === 'about:srcdoc') return 'allow';
    const link = previewWebLink(url);
    return link?.startsWith('https:') ? 'allow' : 'block';
  }
  if (request?.navigationType === 'click' && previewWebLink(url)) return 'ask';
  return 'block';
}

// JSON strings placed inside HTML script elements must escape '<': otherwise
// a model/texture URL containing </script> can become executable markup.
export function htmlScriptValue(value) {
  return JSON.stringify(value).replace(/[<>&\u2028\u2029]/g, character => `\\u${character.charCodeAt(0).toString(16).padStart(4, '0')}`);
}
import { URL as PreviewURL } from 'react-native-url-polyfill';
import { isPreparedMacPdfFile } from './macPdfFiles';
